
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Banner = () => {
    const navigate = useNavigate();
    
    

    // État pour stocker le message sélectionné
    const [message, setMessage] = useState("");

    

    const gotoEntretien = () => {
        const tomaintenance=true;
        navigate(`/productlist`,{ state: { tomaintenance } });
      };

    // Définir un message lors du premier rendu
    useEffect(() => {
        // Liste des messages
    const messages = [
        "Un entretien régulier, c'est la garantie d'une performance optimale.",
        "Prendre soin de tes appareils aujourd'hui, c'est prolonger leur durée de vie demain.",
        "Un appareil bien entretenu, c'est moins de pannes et plus de tranquillité.",
        "L'entretien, c'est préserver ton quotidien. Ne le remets pas à plus tard !",
        "Un petit geste pour tes appareils, un grand pas pour leur longévité.",
        "Planifie l'entretien de tes appareils : une économie d'énergie et de budget.",
        "Un entretien simple aujourd'hui pour éviter les réparations coûteuses demain."
      ];
        // Fonction pour choisir un message aléatoire
        const getRandomMessage = () => {
            const randomIndex = Math.floor(Math.random() * messages.length);
            return messages[randomIndex];
        };
        setMessage(getRandomMessage());
    }, []); // Vide pour ne s'exécuter qu'une seule fois au montage du composant


return (
    <div className='banner'>
    
        {/* Version visible uniquement en petit écran */}
        <div className='d-md-none w-100 p-0'           
            style={{ 
                margin: "0px",
                padding: "0px",
                maxheight:"250px",
                boxSizing: "border-box",
                backgroundColor:"#ffffff",
            }}>

            <div className='col-12 p-0 d-flex align-items-start'>
                <img className=''
                    src={process.env.PUBLIC_URL + '/icons/PictA.svg'}
                    alt="Banner Left"
                    style={{maxWidth:"100%", maxHeight: '100px', objectFit: 'contain' }}
                />
            </div>
            <div className='col-12 m-0 d-flex row align-items-center '>
                <div className='d-flex row align-items-center m-0 h-100  justify-content-center'>
                    <p className="text-center fw-bold">
                        Entretenir tes appareils</p>
                    <span className="text-center text-small">{message}</span>
                    <button
                        className="mt-3 mb-3 col-6 text-small p-1"
                        onClick={() => gotoEntretien()}
                        aria-label="CarboMeter"
                        style={{border:"none" , borderRadius:'12px', color : "white", backgroundColor: 'var(--color-green)'}}
                        >
                        Voir les tutoriels
                        </button>
                </div>
            </div>
            <div className='d-flex align-items-end'>
            
                {/* BannerB (droite) */}
                <img className=''
                    src={process.env.PUBLIC_URL + '/icons/PictB.svg'}
                    alt="Banner Right"
                    style={{width:'100%',objectFit: 'fill' }}
                />
            </div>  
        </div>   

        {/* Version sans ombre pour md+ */}
        <div className='d-none d-md-flex w-100 p-0 justify-content-center'           
            style={{ 
                margin: "0px",
                padding: "0px",
                maxheight:"250px",
                boxSizing: "border-box",
                backgroundColor:"#ffffff",
            }}>

            {/* BannerA (gauche) */}
            <div className='col-2 col-md-3 col-lg-3 p-0 d-flex align-items-start'>
                    <img className=''
                        src={process.env.PUBLIC_URL + '/icons/PictA.svg'}
                        alt="Banner Left"
                        style={{maxWidth:"100%", objectFit: 'contain' }}
                    />
            </div>
            {/* Text center */}
            <div className='d-none d-md-block col-12 col-md-5 col-lg-5 p-0 m-0 d-flex row align-items-center '>
                <div className='d-flex row align-items-center m-0 p-0 justify-content-center'>
                    <p className="mt-2 text-center fw-bold">
                        Entretenir vos appareils</p>
                    <span className="text-center text-small">{message}</span>
                    <button
                        className="mt-2 mb-3 col-8 text-small p-1"
                        onClick={() => gotoEntretien()}
                        aria-label="CarboMeter"
                        style={{border:"none" , borderRadius:'12px', color : "white", backgroundColor: 'var(--color-green)'}}
                        >
                        Voir les tutoriels
                    </button>
                </div>
            </div>
            <div className='col-4 col-md-4 col-lg-4 p-0 d-flex align-items-end'>
            
                {/* BannerB (droite) */}
                <img className=''
                    src={process.env.PUBLIC_URL + '/icons/PictB.svg'}
                    alt="Banner Right"
                    style={{width:'100%',objectFit: 'fill' }}

                />
            </div>               
        </div>  
    </div >

    );
};

export default Banner;